import React, { useState, useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import FormFilterDate from "../../components/common/FormFilterDate";
// import { getData } from "../../services/api.service"; // ELIMINADO: módulo comisiones removido (fetchStats lo usaba)
import { FaBox, FaDollarSign, FaCheckCircle, FaClock /*, FaChartLine, FaPercentage */ } from "react-icons/fa"; // FaChartLine y FaPercentage: ELIMINADO - módulo comisiones removido

const VendedorDashboardPage = () => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState({
    totalPedidos: 0,
    pedidosCompletados: 0,
    pedidosPendientes: 0,
    totalVentas: 0
    // comisionTotal: 0,   // ELIMINADO: módulo comisiones removido
    // comisionGanada: 0,  // ELIMINADO: módulo comisiones removido
    // tasaComision: 0     // ELIMINADO: módulo comisiones removido
  });
  const [dateRange, setDateRange] = useState({
    date_from: null,
    date_to: null
  });

  // Cargar estadísticas iniciales (último mes)
  useEffect(() => {
    const today = new Date();
    const lastMonth = new Date();
    lastMonth.setMonth(lastMonth.getMonth() - 1);
    
    const initialRange = {
      date_from: lastMonth.toISOString().split('T')[0],
      date_to: today.toISOString().split('T')[0]
    };
    
    setDateRange(initialRange);
    // fetchStats(initialRange); // ELIMINADO: módulo comisiones removido
  }, []);

  /* ELIMINADO: módulo comisiones removido — fetchStats dependía de /api/commissions/my-stats
  const fetchStats = async (dates) => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (dates.date_from) params.append('start_date', dates.date_from);
      if (dates.date_to) params.append('end_date', dates.date_to);
      
      const response = await getData(`/api/commissions/my-stats?${params.toString()}`);

      if (response.data && response.data.success) {
        const stats = response.data.data.statistics;
        setStats({
          totalPedidos: stats.total_orders || 0,
          pedidosCompletados: stats.completed_orders || 0,
          pedidosPendientes: stats.pending_orders || 0,
          totalVentas: parseFloat(stats.total_sales) || 0,
        });
      }
    } catch (error) {
      console.error("Error al cargar estadísticas:", error);
      setStats({ totalPedidos: 0, pedidosCompletados: 0, pedidosPendientes: 0, totalVentas: 0 });
    } finally {
      setLoading(false);
    }
  };
  */

  const handleDateFilter = (data) => {
    setDateRange(data);
    // fetchStats(data); // ELIMINADO: módulo comisiones removido
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('es-AR', {
      style: 'currency',
      currency: 'ARS',
      minimumFractionDigits: 0
    }).format(amount);
  };

  const StatCard = ({ icon: Icon, title, value, subtitle, color }) => (
    <div className="col-md-6 col-lg-4 mb-4">
      <div className="card shadow-sm h-100">
        <div className="card-body">
          <div className="d-flex align-items-center mb-3">
            <div className={`rounded-circle p-3 me-3`} style={{ backgroundColor: `${color}20` }}>
              <Icon size={24} color={color} />
            </div>
            <div>
              <h6 className="text-muted mb-0" style={{ fontSize: '0.85rem' }}>{title}</h6>
              <h3 className="mb-0" style={{ color }}>{value}</h3>
              {subtitle && <small className="text-muted">{subtitle}</small>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="container-fluid p-4">
      <div className="row mb-4">
        <div className="col-12">
          <h2 className="mb-1">
            ¡Hola, {user?.username || user?.user_id}! 👋
          </h2>
          <p className="text-muted">Aquí están tus estadísticas de ventas</p>
        </div>
      </div>

      {/* Filtro de fechas */}
      <div className="row mb-4">
        <div className="col-12">
          <FormFilterDate 
            handleInfo={handleDateFilter}
            downloadFile={false}
          />
        </div>
      </div>

      {/* Loading state */}
      {loading && (
        <div className="text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Cargando...</span>
          </div>
        </div>
      )}

      {/* Stats Cards */}
      {!loading && (
        <>
          <div className="row">
            {/* Total Pedidos */}
            <StatCard
              icon={FaBox}
              title="Total Pedidos"
              value={stats.totalPedidos}
              subtitle={`${stats.pedidosCompletados} completados`}
              color="#0d6efd"
            />

            {/* Pedidos Completados */}
            <StatCard
              icon={FaCheckCircle}
              title="Completados"
              value={stats.pedidosCompletados}
              color="#198754"
            />

            {/* Pedidos Pendientes */}
            <StatCard
              icon={FaClock}
              title="Pendientes"
              value={stats.pedidosPendientes}
              color="#ffc107"
            />

            {/* Total Ventas */}
            <StatCard
              icon={FaDollarSign}
              title="Total Ventas"
              value={formatCurrency(stats.totalVentas)}
              color="#6f42c1"
            />

            {/* ELIMINADO: módulo comisiones removido
            <StatCard icon={FaPercentage} title="Comisión Actual" value={`${Number(user?.commission_rate || 0).toFixed(2)}%`} subtitle="Para nuevos pedidos" color="#17a2b8" />
            <StatCard icon={FaChartLine} title="Comisión Total" value={formatCurrency(stats.comisionGanada)} subtitle={`Tasa promedio: ${Number(stats.tasaComision).toFixed(2)}%`} color="#20c997" />
            <StatCard icon={FaDollarSign} title="Comisión pendiente" value={formatCurrency(stats.comisionTotal)} subtitle="Lo que falta por cobrar" color="#fd7e14" />
            */}
          </div>

          {/* Información adicional */}
          <div className="row mt-4">
            <div className="col-12">
              <div className="card shadow-sm">
                <div className="card-body">
                  <h5 className="card-title mb-3">📊 Resumen del Período</h5>
                  <div className="row">
                    <div className="col-md-6">
                      <p className="mb-2">
                        <strong>Período:</strong> {dateRange.date_from} al {dateRange.date_to}
                      </p>
                      <p className="mb-2">
                        <strong>Tasa de conversión:</strong>{" "}
                        {stats.totalPedidos > 0
                          ? ((stats.pedidosCompletados / stats.totalPedidos) * 100).toFixed(1)
                          : 0}%
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p className="mb-2">
                        <strong>Promedio por pedido:</strong>{" "}
                        {stats.totalPedidos > 0
                          ? formatCurrency(stats.totalVentas / stats.totalPedidos)
                          : formatCurrency(0)}
                      </p>
                      {/* ELIMINADO: módulo comisiones removido
                      <p className="mb-2">
                        <strong>Promedio comisión por pedido:</strong>{" "}
                        {stats.pedidosCompletados > 0
                          ? formatCurrency(stats.comisionGanada / stats.pedidosCompletados)
                          : formatCurrency(0)}
                      </p>
                      */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default VendedorDashboardPage;
